import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const getHydrantFlushes = async () => {
  console.log('Getting Hydrant Flushes');
  const result = await tryGet(`/hydrantFlushes`);
  console.log('Hydrant Flushes', result);
  return result.data;
};

export const getHydrantFlush = async (hydrantFlushId) => {
  const result = await tryGet(`/hydrantFlushes/${hydrantFlushId}`);
  return result.data;
};

export const getHydrantFlushLatest = async (hydrantId) => {
  const result = await tryGet(`/hydrantFlushes/latest/${hydrantId}`);
  return result.data;
};

export const getHydrantFlushEdit = async (hydrantFlushId) => {
  const result = await tryGet(`/hydrantFlushes/${hydrantFlushId}/edit`);
  return result.data;
};

export const updateHydrantFlush = async (hydrantFlush) => {
  const result = await tryPut(`/hydrantFlushes`, hydrantFlush);
  return result.data;
};

export const addHydrantFlush = async (hydrantFlush) => {
  const result = await tryPost(`/hydrantFlushes`, hydrantFlush);
  return result.data;
};

export const deleteHydrantFlush = async (hydrantFlushId) => {
  const result = await tryDelete(`/hydrantFlushes/${hydrantFlushId}`);
  return result.data;
}